<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-01-30 15:40 -->
<!-- Description:  -->
<template>
  <div>
    <h4>SALIDAS</h4>
    <div class="row mb-3">
      <div class="col">
        <input class="form-control" type="text" v-model="queryParams.search" placeholder="Buscar" @keyup.enter="getList()" @change="getList()">
      </div>
      <div class="col">
        <SelectEntity v-model="queryParams.entity_id" @change="getList()"></SelectEntity>
      </div>
      <div class="col">
        <input class="form-control" type="date" v-model="queryParams.date_init" @change="getList()">
      </div>
      <div class="col">
        <input class="form-control" type="date" v-model="queryParams.date_end" @change="getList()">
      </div>
    </div>
    <div class="mb-3">
      <button class="btn btn-success" @click="downloadXLS()">
        <i class="fas fa-file-xlsx"></i>
        <span>Descargar Excel</span>
      </button>
    </div>
    <table class="table-sm table table-bordered" id="elReportOutputsTable">
      <thead>
        <tr>
          <th>ID</th>
          <th>FECHA</th>
          <th>RAZON</th>
          <th>OBS</th>
          <th>CANTIDAD</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="l in list" :key="l.id">  
          <td>
            <router-link :to="{name: 'adm.cash-register-show', params: {cashRegisterId: l.cash_register_id}}">{{ l.id }}</router-link>
          </td>
          <td>{{ l.cr_created_date }}</td>
          <td>{{ l.reason_name }}</td>
          <td>{{ l.observation }}</td>
          <td>
            <app-span-money :quantity="l.quantity" :moneyCode="1"></app-span-money>
          </td>
        </tr>
      </tbody>
    </table>
    <app-paginate-simple :pagination="paginationData"
      @change="paginationData.page=$event;getList()"></app-paginate-simple>
  </div>
</template>
<script>
import {AdminService} from "src/lt/admin-module/AdminService.js";
import {myMoment} from "src/utils/myMoment.js";
import SelectEntity from "src/lt/admin-module/entitys/Select.vue";
import { saveTableInExcel } from "src/lt/utils/xlsx";

// script content
export default {
  name: "ReportOutputs",
  components: {
    SelectEntity,
  },

  // directives

  props: {
    //
  },

  data: () => ({
    list: [],
    queryParams: { search: null },
    paginationData: {},
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    this.getList();
  },

  methods: {
    async getList() {
      let res = await AdminService.getCashRegisterOutputs({
        ...this.queryParams,
        page: this.paginationData.page,
        per_page: this.paginationData.per_page,
      });
      this.list = res.data.map(x => {
        x.cr_created_date= myMoment(x.cr_created_at).format('DD/MM/YYYY');
        return x;
      });
      this.paginationData = res;
    },
    downloadXLS() {
      let elTable = document.getElementById("elReportOutputsTable");
      saveTableInExcel(elTable, 'salidas.xlsx');
    }
    //
    //
  }
};
</script>
<style scoped></style>

